import { Component, OnInit, OnDestroy, AfterViewChecked } from '@angular/core';
import { FaqCategory } from './faq.model';
import { StaticContentService } from '../shared/services/static-content.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { ScrollToService } from '../shared';

@Component({
    selector: 'jhi-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy, AfterViewChecked {
    faqCategories: Array<FaqCategory> = [];

    private subscription: Subscription;

    private faqCategoryId: string;

    private faqCategoryItemId: string;

    private faqCategoryItemRank: string;

    constructor(
        private route: ActivatedRoute,
        private staticContentService: StaticContentService,
        private scrollToService: ScrollToService
    ) {}

    ngOnInit(): void {
        this.faqCategoryId = this.route.snapshot.queryParams['category'];
        this.faqCategoryItemId = this.route.snapshot.queryParams['item'];
        this.faqCategoryItemRank = this.route.snapshot.queryParams['rank'];
        this.subscription = this.staticContentService
            .getFaqCategories()
            .subscribe(faqCategories => {
                this.faqCategories = faqCategories;
            });
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngAfterViewChecked(): void {
        if (this.faqCategories.length > 0) {
            if (this.faqCategoryItemId) {
                this.scrollToService.scrollBySelector(`.faq-category-item-${this.faqCategoryItemId}`);
            } else if (this.faqCategoryItemRank) {
                this.scrollToService.scrollBySelector(`.faq-category-item-rank${this.faqCategoryItemRank}`);
            } else if (this.faqCategoryId) {
                this.scrollToService.scrollBySelector(`.faq-category-${this.faqCategoryId}`);
            }
            this.faqCategoryId = null;
            this.faqCategoryItemRank = null;
            this.faqCategoryItemId = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/faq/faq.component.ts